import { Controller } from '@hotwired/stimulus'
import { disable } from '../../../helpers/custom_events_helper'

const NAV_COLLAPSED_CLASS = 'page__nav--collapsed'

export default class extends Controller {
  static targets = ['nav', 'tableFrame', 'activeTableNavLink', 'paginationContainer']

  connect() {
    if (this.hasTableFrameTarget) {

      const firstTableNavLink = this.activeTableNavLinkTargets[0]
      if (firstTableNavLink) {
        this.tableFrameTarget.setAttribute('src', firstTableNavLink)
      }

      const tableFrameObserver = new MutationObserver(() => {
        // if a 'table frame' is present, then the pagination is targeting that frame
        // in this case clicking a pagination link while a new table is loading will cause issues,
        // so we disable the pagination links when the frame becomes busy
        // we should not need to re-enable the links since the pagination will be updated by the new frame
        if (this.tableFrameTarget.getAttribute('busy') != null) {
          this.paginationContainerTarget.querySelectorAll('a').forEach(a => { disable(a) })
        }
      })
      tableFrameObserver.observe(this.tableFrameTarget, { attributeFilter: ['busy'] })

      window.addEventListener('rehydrate-turbo-frame', () => {
        this.tableFrameTarget.reload()
      })
    }
  }

  toggleNav() {
    this.navTarget.classList.toggle(NAV_COLLAPSED_CLASS)
  }

  closeNav() {
    this.navTarget.classList.add(NAV_COLLAPSED_CLASS)
  }

  goBack(event) {
    if (history.length === 2 && event.params.backupUrl) {
      console.log('root_controller#goBack: Tubro.visit: ', event.params.backupUrl)
      Turbo.visit(event.params.backupUrl)
    } else {
      console.log('root_controller#goBack: history.back()')
      history.back()
    }
  }

  handlePerPage(event) {
    const url = new URL(window.location.href)
    url.searchParams.set('per_page', event.target.value)
    url.searchParams.delete('page')
    Turbo.visit(url.toString())
  }
}
